import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { CalendarToday, Add } from '@mui/icons-material';
import colors from '../../../shared-colors';
import AddModal from './AddModal';
import { useTranslation } from 'react-i18next';

const EmptyState = () => {
  const { t } = useTranslation();
  const [showAddModal, setShowAddModal] = useState(false);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 2,
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          backgroundColor: colors.lightBlue,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
        }}
      >
        <CalendarToday sx={{ fontSize: 40, color: colors.mainBlue }} />
      </Box>

      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          color: colors.black,
          mb: 2,
        }}
      >
        {t('noDoctorVisitsFound')}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          color: colors.grayText,
          mb: 4,
          maxWidth: '400px',
          lineHeight: 1.6,
        }}
      >
        {t('noVisitsDescription')}
      </Typography>

      <Button
        variant="contained"
        startIcon={<Add />}
        sx={{
          backgroundColor: colors.mainBlue,
          borderRadius: '50px',
          px: 3,
          py: 1.5,
          textTransform: 'none',
          fontWeight: 500,
          '&:hover': {
            backgroundColor: colors.mainBlue,
            opacity: 0.9,
          },
        }}
        onClick={() => setShowAddModal(true)}
      >
        {t('scheduleVisit')}
      </Button>
      <AddModal open={showAddModal} onClose={() => setShowAddModal(false)} onSubmit={() => {}} />
    </Box>
  );
};

export default EmptyState;
